module.exports =
  accepted: [Number]
  value:    0
